import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { article, button, div, p, section } from "./van/van-tags";
import { scrollIntoView, type ViewComponent } from "./van/view-component";

// It is recommended to attach the error section at the bottom so that other
// view components do not jump when the notification is cleared.
class ErrorSection implements ViewComponent {
	attempt = async <T>(fn: () => Promise<T>): Promise<T | undefined> => {
		this.clear();
		try {
			return await fn();
		} catch (err) {
			this.setText(String(err));
		}
	};

	// Clears the error text and hides the section element
	clear(): void {
		this.#reactive.text = "";
	}

	// Sets the error text and scrolls the error section into view.
	setText(text: string): void {
		this.#reactive.text = text;
		scrollIntoView(this.ChildDom);
	}

	#reactive = reactive({
		text: "",
	});

	ChildDom: ChildDom;

	constructor() {
		this.ChildDom = section(
			{ class: "section" },
			article(
				{
					class: () =>
						this.#reactive.text ? "message is-danger" : "is-hidden",
				},
				div(
					{ class: "message-header" },
					p("Error"),
					button({
						class: "delete",
						onclick: () => this.clear(),
					}),
				),
				div({ class: "message-body" }, () => this.#reactive.text),
			),
		);
	}
}

export const errorSection = new ErrorSection();
